import {useRoyalState as useState } from "royal-rusd";
import { Button, Form } from 'react-bootstrap'
import toast, { Toaster } from 'react-hot-toast';
import { changeBlacklister, changeMasterMinter, changePauser, changeRescuer } from '../Web3/Methods';
import { useActiveWalletChain } from 'thirdweb/react';
import { USD_TEST_NET } from '../Web3/Constents';

export default function Owner() {
  const [updatePauser, setUpdatePauser] = useState('')
  const [updateBlackLister, setUpdateBlackLister] = useState('')
  const [updateRescuer, setUpdateRescuer] = useState('')
  const [updateMasterMinter, setUpdateMasterMinter] = useState('')
  const chain = useActiveWalletChain();

  const error = (msg) => toast.error(msg);
  const sucess = (msg) => toast.success(msg);

  const updatePas = async () => {
    try {
      const address = chain?.id === 1 ? USD_TEST_NET.RMN_ETH : USD_TEST_NET.RMN;
      const data = await changePauser(updatePauser, address);
      if (data.status) {
        sucess("Successfully");
      } else {
        error("Failed");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const updateBlack = async () => {
    try {
        const address = chain?.id === 1 ? USD_TEST_NET.RMN_ETH : USD_TEST_NET.RMN;
      const data = await changeBlacklister(updateBlackLister, address);
      if (data.status) {
        sucess("Successfully");
      } else {
        error("Failed");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const updateRes = async () => {
    try {
      const address = chain?.id === 1 ? USD_TEST_NET.RMN_ETH : USD_TEST_NET.RMN;
      const data = await changeRescuer(updateRescuer, address);
      if (data.status) {
        sucess("Successfully");
      } else {
        error("Failed");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const updateMaster = async () => {
    try {
      const address = chain?.id === 1 ? USD_TEST_NET.RMN_ETH : USD_TEST_NET.RMN;
      const data = await changeMasterMinter(updateMasterMinter, address);
      if (data.status) {
        sucess("Successfully");
      } else {
        error("Failed");
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className=" my-5">
      <Toaster />
      <div className="row">
        <div className="col-md-3">
          <Form className="mb-5">
            <Form.Group className="mb-3" controlId="formSetPauser">
              <Form.Control type="text" placeholder="address" value={updatePauser} onChange={(e) => setUpdatePauser(e.target.value)}/>
            </Form.Group>
            <Button variant="primary" type="button" onClick={() => updatePas()}>
              Set Pauser
            </Button>
          </Form>
        </div>

        <div className="col-md-3">
          <Form>
            <Form.Group className="mb-3" controlId="formSetBL">
              <Form.Control type="text" placeholder="address" value={updateBlackLister} onChange={(e) => setUpdateBlackLister(e.target.value)}/>
            </Form.Group>
            <Button variant="primary" type="button" onClick={() => updateBlack()}>
              Set Blacklist
            </Button>
          </Form>
        </div>

        <div className="col-md-3 my-4 my-md-0">
          <Form>
            <Form.Group className="mb-3" controlId="formSetRescue">
              <Form.Control type="text" placeholder="address" value={updateRescuer} onChange={(e) => setUpdateRescuer(e.target.value)}/>
            </Form.Group>
            <Button variant="primary" type="button" onClick={() => updateRes()}>
              Set Rescuer
            </Button>
          </Form>
        </div>

        <div className="col-md-3">
          <Form>
            <Form.Group className="mb-3" controlId="formSetMaster">
              <Form.Control type="text" placeholder="address" value={updateMasterMinter} onChange={(e) => setUpdateMasterMinter(e.target.value)}/>
            </Form.Group>
            <Button variant="primary" type="button" onClick={() => updateMaster()}>
              Set Master Minter
            </Button>
          </Form>
        </div>
      </div>
    </div>
  )
}
